module.exports = {
    layouts:
      [
        //Streams
        {
          type: 'RECENTLY_VIEWED_STREAMS',
          name: 'Recently Viewed Streams',
          category: 'STREAM',
          description: 'Streams that were recently viewed by the user so they can pick up from exactly where they dropped off.',
          icon: ""
        },
  
        //Collections
        {
          type: 'MY_COLLECTIONS',
          name: 'My Collections',
          category: 'COLLECTION',
          description: 'Collections created by and collaborated with the user so they can find everything they need without leaving the Hub.',
          icon: ""
        },
  
        //Assets
        {
          type: 'MOST_VIEWED_ASSETS',
          name: 'Popular with your teams',
          category: 'ASSET',
          description: 'Assets with the most number of views to easily discover the ones that are a hit among your peers.',
          icon: ""
        },
        {
          type: 'RECENTLY_VIEWED_ASSETS',
          name: 'Continue where you left',
          category: 'ASSET',
          description: 'Assets that were recently viewed by the user so they can pick up from exactly where they dropped off. ',
          icon: "",
          dimensions: '128 * 150 px'
        },
        {
          type: 'RECENTLY_ADDED_ASSETS',
          name: 'Recent additions to Hub',
          category: 'ASSET',
          description: 'Assets that were recently added to the Content Hub so nobody has to doomscroll to find the latest additions.',
          icon: ""
        },
        {
          type: 'RECOMMENDED_ASSETS',
          name: 'Recommended Assets',
          category: 'ASSET',
          description: 'Paperflite’s AI uses a Collaborative Filtering system to recommend Assets to a user based on similar users’ reading patterns.',
          icon: ""
        },
        {
          type: 'RECENTLY_UPDATED_ASSETS',
          name: 'Recently Updated Assets',
          category: 'ASSET',
          description: 'Assets that were recently updated / edited or changed by you and your team on the Content Hub.',
          icon: ""
        } ,
        {
          type: 'FREQUENTLY_SHARED_ASSETS',
          name: 'Frequently Shared Assets',
          category: 'ASSET',
          description: 'Assets that were most shared by your team. Your champion assets!',
          icon: ""
        }
      ]
  };
  
  